import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from './firebase';
import { signOut } from 'firebase/auth';
import AddTherapist from './AddTherapist';
import StudentVerificationList from './StudentVerificationList';
import AdminOrders from './AdminOrders';
import AdminBlogs from './AdminBlogs';
import AdminNewsletters from './AdminNewsletters';
import AdminEvents from './AdminEvents';
import AdminTestimonials from './AdminTestimonials';
import AdminDailyQuotes from './AdminDailyQuotes';
import AdminVoices from './AdminVoices';
import './AdminDashboard.css';

export default function AdminDashboard({ user }) {
  const [activeTab, setActiveTab] = useState('addTherapist');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/');
    } catch (err) {
      alert("Logout failed: " + err.message);
    }
  };

  return (
    <div className="admin-dashboard-container">
      {/* Top Navbar */}
      <nav className="admin-top-nav">
        <div className="admin-nav-logo" onClick={() => navigate("/")}>
          <img src="/Nabi UI Assets/Assets_Images/Logo placeholder.png" alt="Nabi Logo" className="admin-cornerlogo" />
          World of Nabi
        </div>
        
        <div className="admin-nav-right">
          <div className="admin-user-menu" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            <div className="admin-user-icon">
              {user && user.photoURL ? (
                <img src={user.photoURL} alt="User" className="admin-avatar" />
              ) : (
                <span>{user?.email?.[0]?.toUpperCase() || 'T'}</span>
              )}
            </div>
            <span className="admin-login-text">
              {user ? (user.displayName || user.name || user.email?.split('@')[0]) : "tech"}
            </span>

            {isMenuOpen && (
              <div className="admin-dropdown" onClick={(e) => e.stopPropagation()}>
                <div className="admin-menu-item logout" onClick={handleLogout}>
                  Log Out
                </div>
              </div>
            )}
          </div>
        </div>
      </nav>

      {/* Main Layout */}
      <div className="admin-dashboard-wrapper">
        <div className="admin-sidebar">
          <div className="admin-sidebar-header">
            <h2>Admin Dashboard</h2>
            <p>tech@nabi.health</p>
          </div>
          <ul className="admin-nav-list">
            <li 
              className={`admin-nav-item ${activeTab === 'addTherapist' ? 'active' : ''}`}
              onClick={() => setActiveTab('addTherapist')}
            >
              Add Therapists
            </li>
            <li 
              className={`admin-nav-item ${activeTab === 'studentVerification' ? 'active' : ''}`}
              onClick={() => setActiveTab('studentVerification')}
            >
              Student Verification
            </li>
            <li 
              className={`admin-nav-item ${activeTab === 'shiprocketOrders' ? 'active' : ''}`}
              onClick={() => setActiveTab('shiprocketOrders')}
            >
              Shiprocket Orders
            </li>
            <li 
              className={`admin-nav-item ${activeTab === 'manageBlogs' ? 'active' : ''}`}
              onClick={() => setActiveTab('manageBlogs')}
            >
              Manage Blogs
            </li>
            <li 
              className={`admin-nav-item ${activeTab === 'manageNewsletters' ? 'active' : ''}`}
              onClick={() => setActiveTab('manageNewsletters')}
            >
              Manage Newsletters
            </li>
            <li 
              className={`admin-nav-item ${activeTab === 'manageEvents' ? 'active' : ''}`}
              onClick={() => setActiveTab('manageEvents')}
            >
              Manage Events
            </li>
            <li 
              className={`admin-nav-item ${activeTab === 'manageTestimonials' ? 'active' : ''}`}
              onClick={() => setActiveTab('manageTestimonials')}
            >
              Manage Testimonials
            </li>
            <li 
              className={`admin-nav-item ${activeTab === 'manageDailyQuotes' ? 'active' : ''}`}
              onClick={() => setActiveTab('manageDailyQuotes')}
            >
              Manage Daily Quotes
            </li>
            <li 
              className={`admin-nav-item ${activeTab === 'manageVoices' ? 'active' : ''}`}
              onClick={() => setActiveTab('manageVoices')}
            >
              Manage Voices
            </li>
          </ul>
        </div>
        
        <div className="admin-content-area">
          {activeTab === 'addTherapist' && <AddTherapist />}
          {activeTab === 'studentVerification' && <StudentVerificationList />}
          {activeTab === 'shiprocketOrders' && <AdminOrders />}
          {activeTab === 'manageBlogs' && <AdminBlogs />}
          {activeTab === 'manageNewsletters' && <AdminNewsletters />}
          {activeTab === 'manageEvents' && <AdminEvents />}
          {activeTab === 'manageTestimonials' && <AdminTestimonials />}
          {activeTab === 'manageDailyQuotes' && <AdminDailyQuotes />}
          {activeTab === 'manageVoices' && <AdminVoices />}
        </div>
      </div>
    </div>
  );
}
